import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrSalesLandingComponent } from './kn-br-sales-landing.component';
import { IconModule, PageSlotModule } from '@spartacus/storefront';

@NgModule({
    imports: [CommonModule, PageSlotModule, IconModule, KnBrSalesLandingComponent],
    exports: [KnBrSalesLandingComponent],
})

export class KnBrSalesLandingModule { }
